export enum EFontWeight {
  reg = 'fontReg',
  med = 'fontMedium',
  bold = 'fontBold',
}
